import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ProductProcess from './product-process';
import ProductProcessDetail from './product-process-detail';
import ProductProcessUpdate from './product-process-update';
import ProductProcessDeleteDialog from './product-process-delete-dialog';

const ProductProcessRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ProductProcess />} />
    <Route path="new" element={<ProductProcessUpdate />} />
    <Route path=":id">
      <Route index element={<ProductProcessDetail />} />
      <Route path="edit" element={<ProductProcessUpdate />} />
      <Route path="delete" element={<ProductProcessDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ProductProcessRoutes;
